import React from 'react';
import { SuccessPage } from '../SuccessPage';

type ErrorFallbackProps = {
  error: Error;
  resetErrorBoundary: () => void;
};

const ErrorFallback: React.FC<ErrorFallbackProps> = ({
  error,
  resetErrorBoundary,
}) => {
  return (
    <div role="alert" className="p-4">
      <SuccessPage
        icon="failed"
        title={`Oops! Something went wrong.`}
        action={
          <div className="ml-6">
            <h2 className="my-2">{error.message}</h2>
            <h2 className="mb-4">
              We’re sorry for the inconvenience. Please try again later or
              contact our support team at <a>gs.it@polyu.edu.hk</a> for
              assistance.
            </h2>
            <a onClick={resetErrorBoundary} className="btn btn-primary">
              Try again
            </a>
          </div>
        }
      />
    </div>
  );
};

export default ErrorFallback;
